import React, { useEffect, useRef, useState } from "react";
import Abram from '../images/testimonial/Abram.jpg';
import Cepek from '../images/testimonial/Cepek.jpg';
import Clausing from '../images/testimonial/Clausing.jpg';
import Heinrich from '../images/testimonial/Heinrich.jpg';
import Klein from '../images/testimonial/Klein.jpg';
import Mamet from '../images/testimonial/Mamet.jpg';
import Marty from '../images/testimonial/Marty.jpg';
import Nittel from '../images/testimonial/Nittel2.jpeg';
import Schwarz from '../images/testimonial/Schwarz.jpg';

const images = [
  Abram,
  Cepek,
  Clausing,
  Klein,
  Heinrich,// Main
  Mamet,
  Marty,
  Schwarz,
  Nittel,
];

const ImageGridScroll = () => {
  const containerRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const totalHeight = rect.height - windowHeight;
      const scrolled = Math.min(
        Math.max((windowHeight - rect.top) / totalHeight, 0),
        1
      );
      setProgress(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const mainImage = images[4];
  const otherImages = images.filter((_, idx) => idx !== 4);

  // Progress split
  const revealProgress = progress < 0.5 ? 0 : (progress - 0.5) * 2; // mapped 0–0.5 → 0, 0.5–1 → 0–1

  return (
    <div ref={containerRef} className="relative h-[400vh] bg-gray-100">
      {/* Sticky Container */}
      <div className="sticky top-0 flex items-center justify-center h-screen">
        <div className="grid grid-cols-3 grid-rows-3 gap-6 w-[90vmin] h-[90vmin]">
          {Array(9)
            .fill(null)
            .map((_, i) => {
              if (i === 4) {
                return (
                  <div
                    key="main"
                    className="flex items-center justify-center overflow-hidden rounded-xl"
                  >
                    <img
                      src={mainImage}
                      alt="Main"
                      className="w-full h-full object-cover rounded-xl shadow-xl"
                    />
                  </div>
                );
              }

              const index = i < 4 ? i : i - 1;

              // Bilder erscheinen erst in Phase 2 (revealProgress)
              const scale = 0.3 + 0.7 * revealProgress;
              const opacity = revealProgress;

              return (
                <div
                  key={i}
                  className="flex items-center justify-center overflow-hidden rounded-xl"
                  style={{
                    opacity,
                    transform: `scale(${scale})`,
                    transition: "opacity 0.6s linear, transform 0.6s linear",
                  }}
                >
                  <img
                    src={otherImages[index]}
                    alt={`img-${i}`}
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ImageGridScroll;
